export default [
    'en_US',
    'zh_CN',
    'ms_MY'
];
